export enum MediaType {
    IMAGE,
    JSON,
}

export function mediaTypeRegExp(mediaType: MediaType): RegExp {
    if (mediaType === MediaType.IMAGE) {
        return /(.png|.jpg|.jpeg)/
    }

    return /.json/
}
